import { extends as _extends } from '../../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { useField } from 'react-final-form';

var Hidden = function Hidden(_ref) {
  var name = _ref.name;
  var _useField = useField(name),
    input = _useField.input;
  return /*#__PURE__*/React.createElement("input", _extends({
    type: "hidden"
  }, input));
};
var Hidden$1 = Hidden;

export { Hidden$1 as default };
//# sourceMappingURL=Hidden.js.map
